console.log("B2B hooks")
window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}

function checkRequireCheckbox({ BSS_B2B, isValidate }) {
    let listCheckbox = document.querySelectorAll(`.formbuilder-checkbox-group.form-group:has(span.formbuilder-required) input`);
    BSS_B2B.RF.listErrCheckboxRequire = [];
    listCheckbox.forEach((checkbox) => {
        if(!checkbox.checked) {
            isValidate = false;
            BSS_B2B.RF.listErrCheckboxRequire.push(checkbox);
        }
    })
    return isValidate;
}

function showErrFieldForm({ BSS_B2B, textColorFail, requireFieldMessage}) {
    BSS_B2B.RF.listErrFieldsRequire.forEach((errField) => {
        BSS_B2B.RF.handleErrorValidate(errField, requireFieldMessage);
    })
    BSS_B2B.RF.listErrCheckboxRequire.forEach((errCheckbox) => {
        $(`.formbuilder-checkbox-group.form-group:has(input[name="${errCheckbox.name}"])`).append(`<p class="bss-error-msg" style="text-align: center; color: ${textColorFail}">` + requireFieldMessage + `</p>`);
    })
    $([document.documentElement, document.body]).animate({
        scrollTop: 500
    }, 1500);
    return true;
}

window.BSS_B2B.addFilter(`check_require_checkbox`, checkRequireCheckbox);
window.BSS_B2B.addFilter(`show_err_field_form`, showErrFieldForm);